import React, { useEffect } from "react";
import "./App.css";
import { verifyCampaign } from "./service/verify-service";
import { goToLandingPage, goToMBALHome } from "./utils";

function App() {
  useEffect(() => {
    const campaignCode = new URLSearchParams(window.location.search).get("i");
    const idCardNo = new URLSearchParams(window.location.search).get("p");
    const documentTitle = 'MBAL';
    document.title = documentTitle ? `${documentTitle} - ${campaignCode}` : documentTitle;
    if (campaignCode) {
      verifyCampaign(campaignCode, idCardNo)
        .then((response) => {
          goToLandingPage(response.data);
        })
        .catch((error) => {
          goToMBALHome();
        });
    } else {
      goToMBALHome();
    }
  }, []);

  return <div></div>;
}

export default App;
